<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="red darken-2"
          v-if="canBeFolderDestroyed()"
          dark
          v-on="on"
        >
          <v-icon small left>mdi-delete</v-icon>
          Remover
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>
          Remover Processo
        </v-card-title>
        <v-card-text>

          Deseja remover o processo {{folder.process_number}}? Essa ação não poderá ser revertida

        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              flat
              color="black darken-2"
              @click="dialog = false"
              :disabled="processing"
            >
              Cancelar
            </v-btn>
            <v-btn
              flat
              color="red darken-2"
              @click="destroyFolder()"
              :loading="processing"
            >
              Confirmar
            </v-btn>

          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogResponse" persistent max-width="450">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Processo removido com sucesso
        </v-card-title>
        <v-card-text>
          O processo foi removido com sucesso. Ao clicar em confirmar, essa janela será fechada automaticamente.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close()">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import folderService from '@/services/FoldersService';
import { isEmpty } from 'lodash';
export default {
  name: 'DestroyFolderDialog',
  data() {
    return {
      dialog: false,
      dialogResponse: false,
      processing: false,
    };
  },
  props: [],
  mounted() {
  },
  methods: {
    close() {
      window.close();
    },
    destroyFolder() {
      this.processing = true;
      folderService.destroyFolder(this.folder.id)
        .then(() => {
          this.dialogResponse = true;
          this.dialog = false;
        })
        .catch((err) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: err.response.data,
            messageIcon: 'mdi-alert-outline',
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },
    canBeFolderDestroyed() {
      return !this.folderArchived &&
        isEmpty(this.folder.documents) &&
        isEmpty(this.folder.transactions) &&
        (this.folder.user.id === this.user.id);
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    user() {
      return this.$store.getters.user;
    },
    folderArchived() {
      return this.$store.getters.folderStatusArchived.name === this.folder.folder_status.name;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/DestroyFolderDialog.vue